const invoiceMapper = (dataResponse) => {
  try {
      if (!dataResponse || !dataResponse.data || !Array.isArray(dataResponse.data)) {
          throw new Error("Datos inválidos");
      }

      const responseTableMapper = dataResponse.data.map(item => ({
          id: item.id ?? '',
          "Número factura": item.numero_factura ?? '',
          "Fecha emisión": item.fecha_emision ?? '',
          Identificación: item.identification ?? '',
          Cliente: item.nombres + ' ' +  item.apellidos ?? ''
      }));

      return {
          error: false,
          variant: "success",
          responseTableMapper,
          page: dataResponse.page,
          per_page: dataResponse.per_page,
          total_records: dataResponse.total_records,
          total_pages: dataResponse.total_pages,
          url: dataResponse.url
      };
  } catch (error) {
      return {
          error: true,
          variant: "error",
          message: error.message || "Error al procesar los datos"
      };
  }
};

/*const invoiceMapper = (data, error) => {
  let responseData = [];
  let responseResp = [];
  if(!error){
    for (var i = 0; i < data.data.length; i++) {
      responseData[i] = {
        id: data.data[i].id ?? '',
        "N Factura": data.data[i].numero_factura ?? '',
        "Fecha ingreso": data.data[i].fecha_emision ?? '',
        Turno: data.data[i].code ?? '',
        "Identificación": data.data[i].identification ?? '',
        name: data.data[i].name + ' ' + data.data[i].last_name ?? '',
        "Estado SRI": data.data[i].status === "1" ? 'Ingresada' : data.data[i].status === "2" ? 'Emitida' : data.data[i].status === "3" ? 'Anulada' : 'Pagada',
        //"Estado Sri": data.data[i].status ?? '',
        //Observacion: data.data[i].observation ?? ''
      }
      responseData.push();
    }
  }
  responseResp = {
    error: data.error ?? '',
    message: data.message ?? '',
    variant: data.variant ?? ''
  }
  const response = {
    responseData,
    responseResp
  }
  return response;
}*/

const invoiceByIdMapper = (data, error) => {
  let responseData = [];
  let responseResp = [];
  if(!error){
    for (var i = 0; i < data.data.length; i++) {
      responseData[i] = {
        id: data.data[i].invoice_id ?? '',
        numero_factura: data.data[i].numero_factura ?? '',
        fecha_emision: data.data[i].fecha_emision ?? '',
        code: data.data[i].code ?? '',
        identification: data.data[i].identification ?? '',
        name: data.data[i].nombres ?? '',
        last_name: data.data[i].apellidos ?? '',
        phone: data.data[i].phone ?? '',
        email: data.data[i].email ?? '',
        direction: data.data[i].direction ?? '',
        estado: data.data[i].estado ?? '',
        status: data.data[i].status ?? '',
        fecha_autorizacion: data.data[i].fecha_autorizacion ?? '',
        xml_generado: data.data[i].xml_generado ?? '',
        xml_firmado: data.data[i].xml_firmado ?? '',
        xml_autorizado: data.data[i].xml_autorizado ?? '',
        pdf_url: data.data[i].pdf_url ?? '',
        descripcion_producto: data.data[i].descripcion_producto ?? '',
        cantidad: data.data[i].cantidad ?? '',
        precio_unitario: data.data[i].precio_unitario ?? '',
        subtotal: data.data[i].subtotal ?? '',
        descuento: data.data[i].descuento ?? '',
        iva: data.data[i].iva ?? '',
        total: data.data[i].total ?? '',
        observation: data.data[i].observation ?? '',
        ruc: data.data[i].ruc ?? '',
        bname: data.data[i].bname ?? '',
        bphone: data.data[i].bphone ?? '',
        bemail: data.data[i].bemail ?? '',
        bdirection: data.data[i].bdirection ?? '',
        bimg: data.data[i].bimg ?? '',
        invoiceDetail: data.data[i].invoiceDetail
      }
      responseData.push();
    }
  }
  responseResp = {
    error: data.error ?? '',
    message: data.message ?? '',
    variant: data.variant ?? ''
  }
  const response = {
    responseData,
    responseResp
  }
  return response;
}

const inoviceMapper = {
  invoiceMapper,
  invoiceByIdMapper
}

export default inoviceMapper;
